import { Injectable, isDevMode } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http'

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { PROD_API_URL, DEV_API_URL, GOOGLE_CLIENT_ID } from './global-vars';
import { ILoginCredentials, IUserCredentials, IFrontPermitions } from './shared.interface';

declare var gapi: any;

@Injectable()
export class AuthService{
    api: string;

    constructor(private http: Http, private _http: HttpClient){
        this.api = (isDevMode()) ? DEV_API_URL : PROD_API_URL;
    }

    //Завершение логина
    login(provider, credentials?){
        let isLoggedIn: Observable<boolean>;
        if (provider === 'credentials' && credentials){
            return this.login_with_credentials(credentials)
            .map((uc: IUserCredentials) => {this.save_credentials(uc); return true;})
            .catch(err => Observable.throw(err));
        }
    }

    //При смене базового роута (нашего внутреннего скоупа: network, payments...)
    //происходит запрос доступов пользователя и сохраняется в json в LS
    front_permissions(): Observable<boolean>{
        return this._http.get<{result: IFrontPermitions;}>(`${this.api}api/service/front-permissions/`, {})
        .map(res => {
            localStorage.setItem('yoola_app:scopes', JSON.stringify(res.result));
            return true;
        }, error => false);
    }

    //Проверка пермишенов для раздела scope (network, payments....)
    check_permissions(scope: string, permission: string[], exact_match = false):boolean {
        let permissions = JSON.parse(localStorage.getItem('yoola_app:scopes'));
        if (permissions && permissions[scope]) {
            let match = permission.filter(p => permissions[scope].includes(p)).length;
            if (exact_match) {
                //Все пермишены должны присутствовать
                return (match == permission.length) ? true : false;
            } else {
                //Хотябы одно вхождение из переданных пермишенов в скоупе
                return (match > 0) ? true : false;
            }
        } else {
            return false;
        }
    }

    check_permissions_by_url(url: string):boolean {
        let router_guard = [
            {url: '/settings/teammates', scope: 'admin', permission: 'admin'},
            {url: '/earnings/verification/youtube', scope: 'earnings', permission: 'view'}
        ];

        // let route = router_guard.filter(route => route.url == url);
        let route = router_guard.filter(route => url.includes(route.url));
        if (!route[0]) return true;
        else return (this.check_permissions(route[0].scope, [route[0].permission])) ? true : false;
    }
    
    //Вернуть текущего пользователя из LS
    get_current_user(): IUserCredentials {
        return {
            email: localStorage.getItem('yoola_app:email'),
            fullname: localStorage.getItem('yoola_app:fullname'),
            picture: localStorage.getItem('yoola_app:picture'),
            iwd: localStorage.getItem('yoola_app:iwd'),
            app_version: localStorage.getItem('yoola_app:version'),
            access_token: localStorage.getItem('yoola_app:token')
        }
    }

    //Логин через форму
    private login_with_credentials(credentials: ILoginCredentials): Observable<any>{
        return this.http.post(`${this.api}api/login/`, credentials)
        .map((res) => res.json() || {})
        .catch((err) => Observable.throw(err));
    }

    //Получение токена гугла
    init_google_auth_system(): Observable<any>{
        return Observable.create((observer) => {
            if (gapi) gapi.load('auth2', () => observer.next(gapi.auth2.init({ client_id: GOOGLE_CLIENT_ID })));
            else observer.error(`Can't initialize gapi`);
        });
    }

    //Логин через гугл
    send_google_token(idToken): Observable<IUserCredentials>{
        return this.http.post(`${this.api}api/login/`, { google_token: idToken})
        .map((res) => res.json() || {})
        .catch((err) => Observable.throw(err));
    }

    //Сохранение текущего пользователя и его сессии в LS
    save_credentials(credentials: IUserCredentials){
        // localStorage.clear();
        localStorage.setItem('yoola_app:email', credentials.email);
        localStorage.setItem('yoola_app:fullname', credentials.fullname);
        localStorage.setItem('yoola_app:token', credentials.access_token);
        localStorage.setItem('yoola_app:picture', credentials.picture);
        localStorage.setItem('yoola_app:iwd', credentials.iwd);
        localStorage.setItem('yoola_app:version', credentials.app_version);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/auth.service.ts